var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2003 10.1933V9.69331H15.2003V10.1933H16.2003ZM8.50029 3.498H9.00029V2.498H8.50029V3.498ZM9.70029 2.998L10.0537 3.35166L10.4076 2.99799L10.0537 2.64433L9.70029 2.998ZM15.2003 10.1933C15.2003 13.8899 12.2001 16.8886 8.50029 16.8886V17.8886C12.7517 17.8886 16.2003 14.4428 16.2003 10.1933H15.2003ZM8.50029 16.8886C4.80053 16.8886 1.80029 13.8899 1.80029 10.1933H0.800293C0.800293 14.4428 4.24886 17.8886 8.50029 17.8886V16.8886ZM1.80029 10.1933C1.80029 6.49675 4.80053 3.498 8.50029 3.498V2.498C4.24886 2.498 0.800293 5.94385 0.800293 10.1933H1.80029ZM6.94686 0.953281L9.34686 3.35167L10.0537 2.64433L7.65373 0.245937L6.94686 0.953281ZM9.34685 2.64434L6.94685 5.04287L7.65374 5.75019L10.0537 3.35166L9.34685 2.64434Z",
    fill: "#13100D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.dc68e059806992ca77286c380a902a12.svg";
export { ForwardRef as ReactComponent };